<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '450px' }"
  [header]="'session.expiringSoon' | translate"
  styleClass="session-timeout-dialog">

  <div class="dialog-content">
    <div class="warning-icon">
      <i class="pi pi-exclamation-triangle"></i>
    </div>

    <p class="warning-message">
      {{ 'session.expiringMessage' | translate }}
    </p>

    <div class="countdown-container">
      <span class="countdown-label">{{ 'session.expiresIn' | translate }}</span>
      <span class="countdown-time">{{ countdownDisplay }}</span>
    </div>

    <p class="action-prompt">
      {{ 'session.stayQuestion' | translate }}
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button
        [label]="'common.logout' | translate"
        icon="pi pi-sign-out"
        (onClick)="onLogout()"
        styleClass="p-button-secondary p-button-outlined"
        [style]="{ 'margin-right': '0.5rem' }">
      </p-button>
      <p-button
        [label]="'session.stayLoggedIn' | translate"
        icon="pi pi-check"
        (onClick)="onStayLoggedIn()"
        styleClass="p-button-primary">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
